/* jshint esversion: 6, -W097 */
/* globals require */
(function (angular) {
    'use strict';
    angular
        .module('enervee')
        .directive('rebateReasons', rebateReasonsDirective)

    /*
     Creates rebate reasons markup
     <rebate-reasons data-reasons="reasons"></rebate-reasons>
     */
    function rebateReasonsDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                reasons: '='
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: rebateReasonsController,
            template: require('@app/shared/rebateReasons/rebateReasonsView.html'),
        };
    }

    rebateReasonsController.$inject = ['$scope'];
    function rebateReasonsController($scope) {
        const vm = this;

        vm.toggleReasons = toggleReasons;
        vm.showReasons = false;

        /**
         * Expands/collapses the rebate reasons
         */
        function toggleReasons() {
            vm.showReasons = !vm.showReasons;
        }
    }

})(angular);
